import { useState } from 'react';

import config from '@/config';
import useQuery from '@/hooks/useQuery';
import useTranslations from '@/i18n/useTranslations';
import SearchNavbarIcon from '@/shared-components/icons/components/navigation/SearchNavbarIcon';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './virtual-list';

export default function SearchFollowing({ userId }) {
  const t = useTranslations('common.profile.inspiring.search');
  const [query, setQuery] = useState({ username: "" });

  const { loading, queryData, loadMoreData } = useQuery(
    `${userId}_following`,
    `${config.apis.api.url}/user/followees/${userId}`,
    query,
    {
      injectToken: true,
      invalidateWhen: [`FOLLOW_ACTION_ON_${userId}`]
    }
  );

  return (
    <section className="search-inspiring__view">
      <div className="search-inspiring__search-field">
        <SearchNavbarIcon className="search-inspiring__search-icon" />

        <input
          type="text"
          className="search-inspiring__search-input"
          onInput={(e) => setQuery({ username: e.target.value })}
          placeholder={t('placeholder')}
          spellCheck={false}
          autoComplete="off"
        />
      </div>
      <div className="search-inspiring__results">
        {loading ? (
          <Loader className="search-inspiring__loading" thin />
        ) : (queryData?.data?.data?.length ?? 0) === 0 ? (
          query.username ? (
            <Text
              className="search-inspiring__no-results"
              paragraph>
              {t('no_results')}
            </Text>
          ) : (
            <Text className="search-inspiring__empty-message" paragraph>
              {t('empty_following')}
            </Text>
          )
        ) : (
          <VirtualList
            key={queryData?.queryString}
            items={queryData?.data}
            onLoadMore={loadMoreData}
          />
        )}
      </div>
    </section>
  );
}
